




















import { Component, Prop, Vue, Mixins, Watch } from 'vue-property-decorator'
import CompanySearchTree from '@/mixins/companySearchTree'

@Component({})
export default class CompanyTree extends Mixins(CompanySearchTree) {
	private companyName = ''
	private selectedCompany: any = []

	@Prop({})
	private company!: any

	@Watch('company', { immediate: true })
	private onCompanyChange() {
		if (this.company && this.company.id) {
			this.selectedCompany = [this.company.id]
		} else {
			this.selectedCompany = []
		}
	}

	private onSearchInput() {
		this.searchCompany(this.companyName)
	}

	private onSelect(selectedKeys: any, e: any) {
		// this.companyName = e.node && e.node.title
		const selectedCompany = {
			title: e.node && e.node.dataRef.title,
			id: e.node && e.node.dataRef.key,
		}
		this.$emit('onSelect', selectedCompany)
	}

	public created() {
		// 不需要“全部”选项
		this.needQuanBu = false
	}
}
